module.exports = __webpack_public_path__ + "static/media/U.d050f0bb.png";